export interface PasswordRequirement {
  label: string;
  met: boolean;
}

export interface PasswordValidation {
  isValid: boolean;
  requirements: PasswordRequirement[];
}

export const validatePassword = (password: string, confirmPassword?: string): PasswordValidation => {
  const requirements: PasswordRequirement[] = [
    {
      label: 'At least 8 characters long',
      met: password.length >= 8
    },
    {
      label: 'Contains at least one uppercase letter',
      met: /[A-Z]/.test(password)
    },
    {
      label: 'Contains at least one lowercase letter',
      met: /[a-z]/.test(password)
    },
    {
      label: 'Contains at least one number',
      met: /[0-9]/.test(password)
    }
  ];

  // Check if passwords match for overall validation, but don't add to visible requirements
  const passwordsMatch = confirmPassword === undefined || (password === confirmPassword && password.length > 0);
  const isValid = requirements.every(req => req.met) && passwordsMatch;

  return {
    isValid,
    requirements
  };
};

export const getPasswordErrorMessage = (password: string, confirmPassword?: string): string | null => {
  const validation = validatePassword(password, confirmPassword);
  
  if (validation.isValid) {
    return null;
  }

  const unmetRequirements = validation.requirements
    .filter(req => !req.met)
    .map(req => req.label);

  return `Password must meet the following requirements: ${unmetRequirements.join(', ')}`;
};
